import type { CustomCellRendererProps } from "ag-grid-react";
import type { UID } from "src/types";
import Users from "../Users";
import { MembersContainer } from "./styles";

interface OwnersCellRendererParams extends CustomCellRendererProps {
  value: Array<UID>;
}

export const OwnersCellRenderer = ({
  value,
}: OwnersCellRendererParams): React.ReactElement => {
  return (
    <MembersContainer>
      <Users users={value ?? []} />
    </MembersContainer>
  );
};
